import { PageHero } from "@/components/primitives";
import WhereAuthority from "@/sections/WhereAuthority";
import FinalCTA from "@/sections/FinalCTA";
import { Reveal } from "@/components/Reveal";
import { SectionShell, Overline } from "@/components/primitives";
import { INDUSTRIES, IMAGES } from "@/data/content";

export default function Industries() {
  return (
    <div data-testid="industries-page">
      <PageHero
        label="Industries"
        lines={["Every sector has", "its own ecosystem."]}
        intro="Influence is industry-specific. We help organizations become visible within the precise networks that shape their sector."
      />

      <SectionShell className="py-24 md:py-36 border-b hairline">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-4 lg:sticky lg:top-32">
            <Reveal><Overline>Sectors We Serve</Overline></Reveal>
            <Reveal delay={0.1}>
              <p className="mt-8 text-lg leading-relaxed text-ink/70 font-body">
                From technology to infrastructure, each industry carries a distinct constellation of
                publications, conferences, communities, and decision-makers. We map yours.
              </p>
            </Reveal>
            <Reveal delay={0.2}>
              <div className="mt-10 relative overflow-hidden aspect-[4/5]">
                <img src={IMAGES.corner} alt="Architecture" className="absolute inset-0 w-full h-full object-cover" loading="lazy" />
              </div>
            </Reveal>
          </div>
          <div className="lg:col-span-7 lg:col-start-6">
            <div className="grid grid-cols-1 sm:grid-cols-2 border-l border-t hairline">
              {INDUSTRIES.map((ind, i) => (
                <Reveal key={ind} delay={i * 0.03}>
                  <div className="group border-r border-b hairline px-6 py-8 hover:bg-mist/60 transition-colors duration-300 h-full">
                    <span className="font-heading text-gold text-xs tracking-widest">{String(i + 1).padStart(2, "0")}</span>
                    <h3 className="mt-3 font-heading font-light text-navy text-xl md:text-2xl">{ind}</h3>
                  </div>
                </Reveal>
              ))}
            </div>
          </div>
        </div>
      </SectionShell>

      <WhereAuthority withHeader={true} />
      <FinalCTA />
    </div>
  );
}
